var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWait(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 33,
    viewBox: "0 0 101 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 100,
    height: 32,
    rx: 16,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 100,
    height: 32,
    rx: 16,
    stroke: "#C7C7C7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.6973 11.8008H30.3145V13.0898H27.6973V16.9766H26.1738V7.71875H27.6973V11.8008ZM14.9434 8.87109H22.6387V10.1406H16.4668V15.1016C18.2897 15.1016 19.7643 15.0625 20.8906 14.9844C22.0169 14.8997 23.14 14.7435 24.2598 14.5156L24.4551 15.7852C23.2702 16.0195 22.0853 16.179 20.9004 16.2637C19.722 16.3483 18.1855 16.3906 16.291 16.3906H14.9434V8.87109ZM16.7012 17.9141H18.2246V20.082H26.1738V17.9141H27.6973V24.7891H16.7012V17.9141ZM26.1738 23.5195V21.3125H18.2246V23.5195H26.1738ZM45.8027 20.5898H44.2598V15.9219H40.1582V17.6211H32.2871V8.89062H33.8105V11.9766H38.6543V8.89062H40.1582V10.9219H44.2598V7.73828H45.8027V20.5898ZM38.6543 16.3516V13.1875H33.8105V16.3516H38.6543ZM34.5723 19.3203H36.1152V23.4219H46.1934V24.7109H34.5723V19.3203ZM44.2598 14.6523V12.2109H40.1582V14.6523H44.2598ZM68.5566 25.082H67.0918V15.9805H64.5332V24.1836H63.127V8.10938H64.5332V14.7109H67.0918V7.71875H68.5566V25.082ZM54.3574 9.84766H60.8613V11.1172H55.8809V19.4766C57.1634 19.4701 58.2507 19.4342 59.1426 19.3691C60.0345 19.2975 60.9395 19.1706 61.8574 18.9883L61.9941 20.2773C61.0176 20.4792 60.054 20.6126 59.1035 20.6777C58.153 20.7428 56.9421 20.7786 55.4707 20.7852H54.3574V9.84766ZM85.3535 25.082H83.8105V7.71875H85.3535V25.082ZM71.2129 20.5703C73.5306 19.4701 75.3047 18.1029 76.5352 16.4688C77.7721 14.8346 78.4785 12.9661 78.6543 10.8633H72.0137V9.61328H80.2168C80.2038 12.2305 79.5397 14.584 78.2246 16.6738C76.9095 18.7637 74.8522 20.4792 72.0527 21.8203L71.2129 20.5703Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWait);
export default __webpack_public_path__ + "static/media/wait.448609cdaeadac8751f13622e5e0dbcd.svg";
export { ForwardRef as ReactComponent };